export default "__VITE_ASSET__Cn9CD1cv__"